import { render, staticRenderFns } from "./integrationConfiguration.vue?vue&type=template&id=2b71c904"
import script from "./integrationConfiguration.vue?vue&type=script&lang=js"
export * from "./integrationConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports